import React from 'react';
import HeroSlider from 'components/Home/HeroSlider';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const SimpleSliderBanner = (props) => {
    const {data, title, creative, autoplay, date} = props;
    return (
        <section className="banner-slider-offer">
            {title && <h1 className="banner-slider-offer-title">{title}</h1>}
            <HeroSlider heroSlider={data} creative={creative} autoplay={autoplay} dateServer={date}/>
        </section>
    );
}

SimpleSliderBanner.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    creative: PropTypes.string,
    autoplay: PropTypes.bool,
    date: PropTypes.number
};

export default SimpleSliderBanner;
